import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  Home,
  MovieDetails,
  MovieCast,
  TvDetails,
  Movies,
  Tv,
} from './components';

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="movie/:movieId" element={<MovieDetails />} />
        <Route path="movie/:movieId/cast" element={<MovieCast />} />
        <Route path="tv/:tvId" element={<TvDetails />} />
        <Route path="movies" element={<Movies />} />
        <Route path="tv" element={<Tv />} />
      </Routes>
    </>
  );
};

export default App;
